import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react'
import { INSTITUTIONAL_EMAIL } from '../services/api'

const footerLinks = [
  { href: '#programa', label: 'Programa Catalisa GOV' },
  { href: '#desafios', label: 'Desafios Prioritários' },
  { href: '#consulta', label: 'Consulta Pública' },
  { href: '#base-legal', label: 'Base Legal' },
]

export function Footer() {
  return (
    <footer className="bg-[#111827] text-gray-300" role="contentinfo">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-[#1D71C3] rounded-lg flex items-center justify-center text-white font-bold text-xs font-serif">
                CG
              </div>
              <div>
                <div className="font-serif font-bold text-white text-sm">Catalisa GOV</div>
                <div className="text-[10px] text-gray-400">Porto Velho</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-gray-400">
              Site institucional do Catalisa GOV Porto Velho, com informações sobre CPSI, desafios
              públicos municipais e consulta pública ao mercado. Uma iniciativa da Prefeitura Municipal de Porto Velho e do Sebrae.
            </p>
          </div>

          <div>
            <h3 className="font-serif font-bold text-white text-sm mb-4">Links Rápidos</h3>
            <ul className="space-y-2 text-sm">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="https://portovelho.ro.gov.br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors inline-flex items-center gap-1"
                >
                  Portal da Prefeitura <ExternalLink size={12} />
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-serif font-bold text-white text-sm mb-4">Contato Institucional</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Mail size={14} className="mt-0.5 shrink-0 text-[#1D71C3]" />
                <span>{INSTITUTIONAL_EMAIL}</span>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={14} className="mt-0.5 shrink-0 text-[#1D71C3]" />
                <span>(69) 3901-3300</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={14} className="mt-0.5 shrink-0 text-[#1D71C3]" />
                <span>
                  Prefeitura Municipal de Porto Velho
                  <br />
                  Porto Velho – RO
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} Prefeitura Municipal de Porto Velho. Todos os direitos reservados.</p>
          <div className="flex items-center gap-4">
            <a href={`mailto:${INSTITUTIONAL_EMAIL}`} className="hover:text-gray-300 transition-colors">
              Ouvidoria
            </a>
            <a href="https://portovelho.ro.gov.br" className="hover:text-gray-300 transition-colors">
              Acesso à Informação (LAI)
            </a>
            <span className="text-gray-600">Política de Privacidade</span>
          </div>
        </div>
      </div>
    </footer>
  )
}